<template>
  <section>
    <v-alert type="info" :value="showInfo" transition="slide-x-transition">
      Entrer toutes les dépenses qui ont été effectuées à l'aide d'argent prit
      directement de la caisse.
      <br />
      Normallement les recus des transactions seront dans le tiroir caisse au
      moment de la fermeture.
    </v-alert>
    <v-form ref="addDpForm" @submit.prevent="addDp">
      <v-row aling="center">
        <v-col cols="12" sm="3">
          <v-text-field
            filled
            dense
            class="no-before"
            hide-details="auto"
            v-model="newDp.raison"
            label="Lieu/Raison"
            :rules="requiredStringRule"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="2">
          <j-decimal-input
            filled
            class="no-before"
            dense
            hide-details
            :value="newDp.montant_av_taxe"
            label="Prix"
            type="number"
            min="0"
            step="0.01"
            suffix="$"
            :rules="requiredValueRule"
            @input="v => updateValue('montant_av_taxe', v)"
          ></j-decimal-input>
        </v-col>
        <v-col cols="6" sm="2">
          <j-decimal-input
            filled
            dense
            class="no-before"
            hide-details
            :value="newDp.tps"
            label="Tps"
            type="number"
            min="0"
            step="0.01"
            suffix="$"
            :rules="valueRule"
            @input="v => updateValue('tps', v)"
          ></j-decimal-input>
        </v-col>
        <v-col cols="6" sm="2">
          <j-decimal-input
            filled
            dense
            class="no-before"
            hide-details
            :value="newDp.tvq"
            label="Tvq"
            type="number"
            min="0"
            step="0.01"
            suffix="$"
            :rules="valueRule"
            @input="v => updateValue('tvq', v)"
          ></j-decimal-input>
        </v-col>
        <v-col cols="12" sm="2">
          <j-decimal-input
            filled
            dense
            class="no-before"
            hide-details
            :value="newDp.montant"
            label="Total"
            type="number"
            min="0"
            step="0.01"
            suffix="$"
            readonly
            :rules="requiredValueRule"
            @input="v => updateValue('montant', v)"
          ></j-decimal-input>
        </v-col>
        <v-col>
          <v-btn large icon color="success" type="submit"
            ><v-icon large>fa-plus-square</v-icon></v-btn
          >
        </v-col>
      </v-row>
      <v-list>
        <TillDirectPurchaseTile
          v-for="(dp, index) in directPurchases"
          :key="index"
          :direct-purchase="dp"
          :index="index"
          @remove="removeDp(index)"
        >
        </TillDirectPurchaseTile>
      </v-list>
    </v-form>
  </section>
</template>

<script>
import round10 from "round10";
import TillDirectPurchaseTile from "./TillDirectPurchaseTile";
export default {
  name: "TillDirectPurchaseSection",
  components: {
    TillDirectPurchaseTile
  },
  props: {
    directPurchases: {
      type: Array,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    valid: {
      type: Boolean,
      required: true
    },
    showInfo: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      newDp: {
        raison: "",
        montant_av_taxe: 0,
        tps: 0,
        tvq: 0,
        montant: 0
      },
      valueRule: [
        v => v !== null || "Veuillez entrer un montant",
        v => v !== "" || "Veuillez entrer un montant",
        v => v >= 0 || "Veuillez enter une valeur"
      ],
      requiredValueRule: [
        v => v !== null || "Veuillez entrer un montant",
        v => v !== "" || "Veuillez entrer un montant",
        v => v > 0 || "Veuillez enter une valeur"
      ],
      requiredStringRule: [
        v =>
          typeof v !== "undefined" || "Veuillez remplir l'information requise",
        v => v !== null || "Veuillez remplir l'information requise",
        v => v !== "" || "Veuillez remplir l'information requise"
      ]
    };
  },
  methods: {
    updateValue(type, value) {
      this.newDp[type] = round10.round10(Math.abs(Number(value)), -2);
      this.newDp.montant = round10.round10(
        this.newDp.montant_av_taxe + this.newDp.tps + this.newDp.tvq,
        -2
      );
    },
    addDp() {
      const isValid = this.$refs.addDpForm.validate();
      if (isValid) {
        const newDirectPurchases = this.directPurchases.push(
          Object.assign({}, this.newDp)
        );
        this.$emit("emit:directPurchases", newDirectPurchases);
        this.$refs.addDpForm.resetValidation();
        this.newDp = {
          raison: "",
          montant_av_taxe: 0,
          tps: 0,
          tvq: 0,
          montant: 0
        };
      }
    },
    removeDp(i) {
      const newDirectPurchases = this.directPurchases.splice(i, 1);
      this.$emit("emit:directPurchases", newDirectPurchases);
    },
    getTotal() {
      const total = round10.round10(
        this.directPurchases.map(p => p.montant).reduce((a, b) => a + b, 0),
        -2
      );
      this.$emit("update:total", total);
      this.$emit("update:valid", total >= 0);
    }
  },
  watch: {
    directPurchases: {
      deep: true,
      handler: "getTotal"
    }
  }
};
</script>

<style scoped></style>
